var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-container',[_c('el-aside',{attrs:{"width":"auto"}},[_c('CommonAside')],1),_c('el-container',[_c('el-header',[_c('CommonHeader')],1),_c('el-main',{staticStyle:{"overflow":"auto","height":"89vh","background-color":"#f5f5f5"}},[_c('CommonTag'),_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }